import { current as _current } from '@reduxjs/toolkit'
import React, { useState, useEffect } from 'react'
import './index.less'
import { useAppSelector } from '@/hooks'
import Method from '@/components/Compare/Method'

export default function MethodCompare() {
  const [currentTags, setCurrentTags] = useState<string[]>([])
  const localInfo = useAppSelector((state) => state.compareInfo.localInfo)
  useEffect(() => {
    const newCurrentTags: string[] = []
    for (let i = 0; i < localInfo.length; i++) {
      const jifaTags = localInfo[i].tags.filter((item) => item.typeName === '技法')
      if (jifaTags.length > 0) {
        for (let j = 0; j < jifaTags[0].tags.length; j++) {
          if (!newCurrentTags.includes(jifaTags[0].tags[j])) {
            newCurrentTags.push(jifaTags[0].tags[j])
          }
        }
      }
    }
    setCurrentTags(newCurrentTags)
  }, [localInfo])

  return (
    <div className='compare-method'>
      <Method currentTags={currentTags} />
    </div>
  )
}
